export class ProductPageRequestError extends Error {
  public constructor(public readonly status: number) {
    super("This page could not load.");
  }
}

export function isProductPageAccessDenied(error: unknown): boolean {
  return (
    error instanceof ProductPageRequestError &&
    (error.status === 401 || error.status === 403)
  );
}
